import { toast } from "react-toastify";
import { USER_TYPE } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

const safeId = (id) => encodeURIComponent(String(id ?? "").trim());

export const submitUserTypeFilterData = async (data = {}) => {
  try {
    const response = await POST(USER_TYPE.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchUserTypeTableAndFilterSchema = async () => {
  try {
    const response = await GET(USER_TYPE.GET_METADATA);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `user/UserType/{id}` — user type + `permissions: string[]` (permission ids). */
export const getUserTypeById = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("User type ID is required");
    return undefined;
  }
  try {
    const response = await GET(`${USER_TYPE.GET_LIST}/${safeId(raw)}`);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `user/UserType` — create (same body shape as PUT update). */
export const createUserType = async (data = {}) => {
  try {
    const response = await POST(USER_TYPE.GET_LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `user/UserType/{id}` — update (name, flags, `permissions` id array). */
export const updateUserType = async (id = "", data = {}) => {
  const raw = String(id ?? "").trim();
  if (!raw) {
    toast.error("User type ID is required");
    return undefined;
  }
  try {
    const response = await PUT(`${USER_TYPE.GET_LIST}/${safeId(raw)}`, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
